import { DriveItem } from '@cs-cms/types';
import { ExecuteEndpoint } from '../base/BaseApiService';

const MS_GRAPH_BASE_URL = 'https://graph.microsoft.com/v1.0';

export class MsGraphService {
  // Encoding sharing URLs https://learn.microsoft.com/en-us/graph/api/shares-get?view=graph-rest-1.0&tabs=javascript#encoding-sharing-urls
  private static urlToSharingToken = (inputUrl: string): string => {
    const utf8Bytes = new TextEncoder().encode(inputUrl);
    const binaryString = Array.from(utf8Bytes, byte => String.fromCharCode(byte)).join('');
    let base64Value = btoa(binaryString);

    base64Value = base64Value.replace(/=+$/, '').replace(/\//g, '_').replace(/\+/g, '-');
    return 'u!' + base64Value;
  };

  // https://learn.microsoft.com/en-us/graph/api/driveitem-get-content?view=graph-rest-1.0&tabs=http
  public async getDriveItem(fileUrl: string): Promise<DriveItem> {
    const shareIdOrEncodedSharingUrl = MsGraphService.urlToSharingToken(fileUrl);
    const endpoint = `${MS_GRAPH_BASE_URL}/shares/${shareIdOrEncodedSharingUrl}/driveItem?select=id,@microsoft.graph.downloadUrl,name`;

    return ExecuteEndpoint<DriveItem>(endpoint, 'GET');
  }
}

export default MsGraphService;
